import { createTypes } from '@client/redux/utils';

const prefix = 'clientDevice';

const types = createTypes(prefix, [
    'WIDTH_UPDATED',
    'HEIGHT_UPDATED',
    'WEBVIEW_OS_UPDATED',
    'SET_CLIENT_OFFSET_TOP',
    'SET_TAB_VISIBILITY'
]);

export default types;
